import { render } from "./DetalleCentroActivacion.vue?vue&type=template&id=ea17d712&scoped=true"
import script from "./DetalleCentroActivacion.vue?vue&type=script&lang=js"
export * from "./DetalleCentroActivacion.vue?vue&type=script&lang=js"

import "./DetalleCentroActivacion.vue?vue&type=style&index=0&id=ea17d712&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea17d712"]])

export default __exports__